import styled from 'styled-components'
import { ButtonHTMLAttributes } from 'react'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { ButtonVariants } from './buttonVariants'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  $isActive?: boolean
  icon?: IconDefinition
  label?: string
  size?: 'xs' | 'sm' | 'lg'
}

const Button = styled(ButtonVariants)<{ $isActive?: boolean }>`
  text-align: left;
  font-weight: 500;
  padding: 5px;
  width: 100%;
  border-radius: 4px;
  text-transform: none;
  justify-content: flex-start;
  &:hover {
    background-color: ${({ $isActive, theme }) => ($isActive ? undefined : theme.colors.lightGrey)};
    color: ${({ $isActive, theme }) => ($isActive ? undefined : theme.colors.darkText)};
  }
`

const MenuItem = ({ $isActive, icon, size, label, ...props }: ButtonProps) => {
  return (
    <Button
      $isActive={$isActive}
      variant={$isActive ? 'primary' : 'transparent'}
      size={size}
      icon={icon}
      {...props}
    >
      {label}
    </Button>
  )
}

export default MenuItem
